export default "__VITE_ASSET__2e57669e__"